import { CommonRouter } from '@primeit/components-vue';
import { state } from './state';

CommonRouter.registerRoutes([
  {
    beforeEnter: (to, from, next) => {
      state.register();
      next();
    },
    children: [
      {
        component: () => import(/* webpackChunkName: "security.eso" */ './Eso.vue'),
        meta: {
          visible: false,
        },
        path: ':id',
      },
    ],
    component: () => import(/* webpackChunkName: "security.common" */ '../common/Dummy.vue'),
    meta: {
      visible: false,
    },
    path: '/eso',
  },
]);
